export const manifest = {
  short_name: 'Dimorder',
  name: 'Dimorder',
  display: 'standalone',
  theme_color: '#000000',
  background_color: '#ffffff',
  icons: [
    {
      src: 'icons/icon-512x512.png',
      sizes: '512x512',
      type: 'image/png',
    },
  ],
  start_url: '.',
}



// WEBPACK FOOTER //
// ./src/constants/manifest.js